import { useRef } from "react";
import { X, Send, Loader2 } from "lucide-react";
import EmailAssetToolbar from "@/components/admin/EmailAssetToolbar";

const TEMPLATES = [["custom", "Message libre"], ["reminder", "Rappel"], ["cancellation", "Annulation"]];

/** Bulk e-mail to the selected event participants. */
export default function EventBulkEmailModal({ count, template, onTemplate, subject, setSubject, body, setBody, sending, onSubmit, onClose }) {
  const ref = useRef(null);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" data-testid="bulk-email-modal">
      <form onSubmit={onSubmit} className="relative max-h-[90vh] w-full max-w-2xl overflow-y-auto rounded-2xl bg-white p-6 shadow-xl">
        <button type="button" onClick={onClose} className="absolute right-3 top-3 grid h-8 w-8 place-items-center rounded-full hover:bg-neutral-100" aria-label="Fermer" data-testid="bulk-email-close"><X className="h-4 w-4" /></button>
        <h2 className="text-lg font-bold text-navy">Envoyer un e-mail</h2>
        <p className="mt-1 text-xs text-neutral-500" data-testid="bulk-email-count">{count} participant{count > 1 ? "s" : ""} sélectionné{count > 1 ? "s" : ""}</p>
        <div className="mt-4 flex flex-wrap gap-2">
          {TEMPLATES.map(([k, l]) => (
            <button key={k} type="button" onClick={() => onTemplate(k)} data-testid={`bulk-email-tpl-${k}`}
              className={`rounded-full px-3 py-1 text-xs font-semibold ${template === k ? "bg-navy text-white" : "border border-neutral-200 text-neutral-700 hover:bg-neutral-50"}`}>{l}</button>
          ))}
        </div>
        <label className="mt-4 block text-xs font-semibold text-neutral-600">Objet
          <input value={subject} onChange={(e) => setSubject(e.target.value)} required className="mt-1 w-full rounded-xl border border-neutral-200 px-3 py-2 text-sm font-normal" data-testid="bulk-email-subject" />
        </label>
        <label className="mt-3 block text-xs font-semibold text-neutral-600">Message (texte ou HTML)</label>
        <div className="mt-1"><EmailAssetToolbar textareaRef={ref} value={body} onChange={setBody} testidPrefix="bulk-email-asset" /></div>
        <textarea ref={ref} value={body} onChange={(e) => setBody(e.target.value)} required rows={10}
          className="mt-2 w-full rounded-xl border border-neutral-200 px-3 py-2 font-mono text-xs" data-testid="bulk-email-body" />
        <p className="mt-1 text-[11px] text-neutral-400">« Bonjour Prénom, » et un bouton vers la page de l'événement sont ajoutés automatiquement.</p>
        <div className="mt-5 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="rounded-full border border-neutral-200 px-5 py-2 text-sm font-semibold text-neutral-700" data-testid="bulk-email-cancel">Annuler</button>
          <button type="submit" disabled={sending} className="inline-flex items-center gap-2 rounded-full bg-wine-500 px-5 py-2 text-sm font-bold text-white hover:bg-wine-600 disabled:opacity-50" data-testid="bulk-email-submit">
            {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}Envoyer à {count}
          </button>
        </div>
      </form>
    </div>
  );
}
